import React from 'react';
import { connect } from 'react-redux';
import { setDashboardParams } from '../../../../store/actions';

class DashboardOfficeSelector extends React.Component {
  handleSelection = (ev) => {
    ev.preventDefault();
    this.props.setSelectedScript(+ev.target.value);
  };

  render() {
    return (
      <div>
        <div className="box-select-wrapper primary-text">
          <select
            className="box-selector"
            onChange={this.handleSelection}
            value={this.props.selectedScript}
          >
            <option key="0" value={0} disabled>
              - -
            </option>
            {(this.props.scripts || []).map((script) => (
              <option key={script.id} value={script.id}>
                {script.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  scripts: state.scripts.data,
  selectedScript: state.dashboardParams.selectedScript,
  focusedCampaign: state.session.focusedCampaign,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedScript: (id) => dispatch(setDashboardParams({ selectedScript: id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardOfficeSelector);
